/* Eman Store — theme behaviour
   Vanilla JS only. No frameworks, no build step. */
(function () {
  'use strict';

  var T = window.EmanTheme || {};
  var routes = T.routes || {};

  /* ---------------------------------------------------------------- utils */
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  function formatMoney(cents) {
    var fmt = T.moneyFormat || 'AED {{amount}}';
    var value = (cents / 100).toFixed(2).replace(/\.00$/, '');
    value = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, value);
  }

  function toast(msg) {
    var el = document.getElementById('Toast');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.classList.remove('is-visible'); }, 2600);
  }

  function lockScroll(on) {
    document.body.classList.toggle('overflow-hidden', !!on);
  }

  /* --------------------------------------------------------------- drawers */
  var openDrawer = null;

  function drawerOpen(id) {
    var d = document.getElementById(id);
    if (!d) return;
    if (openDrawer && openDrawer !== d) drawerClose(openDrawer);
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    openDrawer = d;
    lockScroll(true);
    var focusable = d.querySelector('input, button, a');
    if (focusable) setTimeout(function () { focusable.focus(); }, 120);
  }

  function drawerClose(d) {
    d = d || openDrawer;
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    if (openDrawer === d) openDrawer = null;
    lockScroll(false);
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      drawerOpen(opener.getAttribute('data-drawer-open'));
      return;
    }
    if (e.target.closest('[data-drawer-close]') || e.target.classList.contains('drawer__overlay')) {
      e.preventDefault();
      drawerClose(e.target.closest('.drawer'));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openDrawer) drawerClose();
  });

  /* ------------------------------------------------------------------ cart */
  function renderFreeShipping(total) {
    var wraps = $$('[data-free-shipping]');
    if (!wraps.length) return;
    var fs = T.freeShipping || {};
    wraps.forEach(function (wrap) {
      if (!fs.enabled || !fs.threshold) { wrap.hidden = true; return; }
      wrap.hidden = false;
      var remaining = fs.threshold - total;
      var msgEl = wrap.querySelector('[data-free-shipping-msg]');
      var bar = wrap.querySelector('.progress__bar');
      if (remaining <= 0) {
        if (msgEl) msgEl.innerHTML = T.strings.freeShippingReached;
        if (bar) bar.style.width = '100%';
      } else {
        if (msgEl) msgEl.innerHTML = (T.strings.freeShippingRemaining || '')
          .replace('__amount__', '<strong>' + formatMoney(remaining) + '</strong>');
        if (bar) bar.style.width = Math.min(100, (total / fs.threshold) * 100) + '%';
      }
    });
  }

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function refreshCart(open) {
    return fetch(routes.cart_url + '?section_id=cart-drawer-content', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-content]');
        var target = $('[data-cart-content]');
        if (fresh && target) target.innerHTML = fresh.innerHTML;
        return fetch(routes.cart_url + '.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        renderFreeShipping(cart.total_price);
        if (open) drawerOpen('CartDrawer');
        return cart;
      })
      .catch(function () { /* fail silently, page still works */ });
  }

  function addToCart(formData, button) {
    if (button) { button.setAttribute('aria-disabled', 'true'); }
    return fetch(routes.cart_add_url, {
      method: 'POST',
      headers: { Accept: 'application/javascript' },
      body: formData
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) {
          toast(res.data.description || res.data.message || T.strings.unavailable);
          return;
        }
        toast(T.strings.added);
        return refreshCart(true);
      })
      .catch(function () { toast(T.strings.unavailable); })
      .finally(function () { if (button) button.removeAttribute('aria-disabled'); });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    addToCart(new FormData(form), form.querySelector('[type="submit"]'));
  });

  document.addEventListener('click', function (e) {
    var change = e.target.closest('[data-cart-change]');
    if (change) {
      e.preventDefault();
      var line = change.getAttribute('data-line');
      var qty = parseInt(change.getAttribute('data-qty'), 10);
      fetch(routes.cart_change_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      }).then(function () { refreshCart(false); });
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty-input]');
    if (!input) return;
    var qty = Math.max(0, parseInt(input.value, 10) || 0);
    fetch(routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: input.getAttribute('data-line'), quantity: qty })
    }).then(function () { refreshCart(false); });
  });

  /* quantity steppers (non-cart) */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (!step) return;
    var input = step.parentNode.querySelector('input');
    if (!input) return;
    var v = parseInt(input.value, 10) || 1;
    v += parseInt(step.getAttribute('data-qty-step'), 10);
    input.value = Math.max(parseInt(input.min || 1, 10), v);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* --------------------------------------------------------- variant picker */
  function initProductForm(root) {
    var data = root.querySelector('[data-variants-json]');
    if (!data) return;
    var variants = JSON.parse(data.textContent);
    var idInput = root.querySelector('[data-variant-id-input]');
    var priceEl = root.querySelector('[data-price-wrap]');
    var submit = root.querySelector('[data-add-button]');
    var stockEl = root.querySelector('[data-stock]');
    var skuEl = root.querySelector('[data-sku]');
    var stickyPrice = document.querySelector('[data-sticky-price]');

    function currentOptions() {
      return $$('[data-option-index]', root).map(function (group) {
        var sel = group.querySelector('.is-selected');
        return sel ? sel.getAttribute('data-value') : null;
      });
    }

    function match(opts) {
      return variants.find(function (v) {
        return opts.every(function (o, i) { return o === null || v.options[i] === o; });
      });
    }

    function updateAvailability(opts) {
      $$('[data-option-index]', root).forEach(function (group) {
        var idx = parseInt(group.getAttribute('data-option-index'), 10);
        $$('[data-value]', group).forEach(function (btn) {
          var test = opts.slice();
          test[idx] = btn.getAttribute('data-value');
          var v = variants.find(function (variant) {
            return test.every(function (o, i) { return o === null || variant.options[i] === o; });
          });
          btn.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }

    function update() {
      var opts = currentOptions();
      updateAvailability(opts);

      $$('[data-option-index]', root).forEach(function (group) {
        var out = group.querySelector('[data-selected-value]');
        var sel = group.querySelector('.is-selected');
        if (out) out.textContent = sel ? sel.getAttribute('data-value') : '';
      });

      var incomplete = opts.some(function (o) { return o === null; });
      var variant = incomplete ? null : match(opts);

      if (!variant) {
        if (submit) {
          submit.setAttribute('aria-disabled', 'true');
          submit.textContent = incomplete ? T.strings.selectOptions : T.strings.unavailable;
        }
        return;
      }

      if (idInput) idInput.value = variant.id;
      if (skuEl) { skuEl.textContent = variant.sku || ''; skuEl.hidden = !variant.sku; }
      if (priceEl && variant.price_html) priceEl.innerHTML = variant.price_html;
      if (stickyPrice) stickyPrice.innerHTML = formatMoney(variant.price);

      if (stockEl) {
        stockEl.hidden = false;
        stockEl.className = 'stock' + (!variant.available ? ' stock--out' : (variant.inventory_quantity > 0 && variant.inventory_quantity <= 3 ? ' stock--low' : ''));
        stockEl.textContent = stockEl.getAttribute(
          !variant.available ? 'data-out' : (variant.inventory_quantity > 0 && variant.inventory_quantity <= 3 ? 'data-low' : 'data-in')
        ) || '';
      }

      if (submit) {
        if (variant.available) {
          submit.removeAttribute('aria-disabled');
          submit.textContent = T.strings.addToBag;
        } else {
          submit.setAttribute('aria-disabled', 'true');
          submit.textContent = T.strings.soldOut;
        }
      }

      if (variant.featured_media_index !== null && variant.featured_media_index !== undefined) {
        goToSlide(variant.featured_media_index);
      }

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
      root.setAttribute('data-current-variant-title', variant.title);
    }

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-value]');
      if (!btn) return;
      e.preventDefault();
      var group = btn.closest('[data-option-index]');
      $$('[data-value]', group).forEach(function (b) { b.classList.remove('is-selected'); b.setAttribute('aria-pressed', 'false'); });
      btn.classList.add('is-selected');
      btn.setAttribute('aria-pressed', 'true');
      update();
    });

    /* gallery */
    var slidesWrap = root.parentNode.querySelector('[data-gallery-slides]') || document.querySelector('[data-gallery-slides]');
    function goToSlide(i) {
      if (!slidesWrap) return;
      var slide = slidesWrap.children[i];
      if (!slide) return;
      slidesWrap.scrollTo({ left: slide.offsetLeft - slidesWrap.offsetLeft, behavior: 'smooth' });
      $$('[data-gallery-thumb]').forEach(function (t, ti) { t.classList.toggle('is-active', ti === i); });
    }
    window.EmanGoToSlide = goToSlide;

    update();
  }

  /* ---------------------------------------------------------------- gallery */
  function initGallery() {
    var slides = $('[data-gallery-slides]');
    if (!slides) return;

    function goTo(i) {
      var slide = slides.children[i];
      if (slide) slides.scrollTo({ left: slide.offsetLeft - slides.offsetLeft, behavior: 'smooth' });
    }
    function setActive(i) {
      $$('[data-gallery-thumb]').forEach(function (t, ti) { t.classList.toggle('is-active', ti === i); });
      $$('[data-gallery-dot]').forEach(function (d, di) { d.classList.toggle('is-active', di === i); });
    }

    $$('[data-gallery-thumb]').forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { goTo(i); setActive(i); });
    });
    $$('[data-gallery-dot]').forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); setActive(i); });
    });

    var counter = $('[data-gallery-counter]');
    slides.addEventListener('scroll', function () {
      var i = Math.round(Math.abs(slides.scrollLeft) / slides.clientWidth);
      if (counter) counter.textContent = (i + 1) + ' / ' + slides.children.length;
      setActive(i);
    }, { passive: true });


    var modal = $('#ZoomModal');
    if (modal) {
      slides.addEventListener('click', function (e) {
        var img = e.target.closest('img');
        if (!img) return;
        modal.querySelector('img').src = img.getAttribute('data-zoom') || img.src;
        modal.classList.add('is-open');
        lockScroll(true);
      });
      modal.addEventListener('click', function () { modal.classList.remove('is-open'); lockScroll(false); });
    }
  }

  /* ------------------------------------------------------------- slideshow */
  function initSlideshow(root) {
    var slides = $$('[data-slide]', root);
    if (slides.length < 1) return;
    var dots = $$('[data-slide-dot]', root);
    var index = 0;
    var interval = parseInt(root.getAttribute('data-autoplay') || '0', 10);
    var timer;

    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, si) { s.classList.toggle('is-active', si === index); });
      dots.forEach(function (d, di) {
        d.classList.toggle('is-active', di === index);
        d.setAttribute('aria-current', di === index ? 'true' : 'false');
      });
    }
    function next() { show(index + 1); }
    function start() { if (interval > 0 && slides.length > 1) { stop(); timer = setInterval(next, interval); } }
    function stop() { clearInterval(timer); }

    $$('[data-slide-next]', root).forEach(function (b) { b.addEventListener('click', function () { next(); start(); }); });
    $$('[data-slide-prev]', root).forEach(function (b) { b.addEventListener('click', function () { show(index - 1); start(); }); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { show(i); start(); }); });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    var startX = null;
    root.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 50) { (dx < 0) === !T.rtl ? next() : show(index - 1); start(); }
      startX = null;
    });

    show(0);
    start();
  }

  /* ------------------------------------------------------------- carousels */
  function initCarousels() {
    $$('[data-carousel]').forEach(function (track) {
      var id = track.getAttribute('data-carousel');
      $$('[data-carousel-prev="' + id + '"], [data-carousel-next="' + id + '"]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = btn.hasAttribute('data-carousel-next') ? 1 : -1;
          if (T.rtl) dir *= -1;
          track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: 'smooth' });
        });
      });
    });
  }

  /* ------------------------------------------------------------- accordions */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-accordion]');
    if (!btn) return;
    var expanded = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', String(!expanded));
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (panel) panel.classList.toggle('is-open', !expanded);
  });

  /* ---------------------------------------------------- predictive search */
  function initSearch() {
    var input = $('[data-predictive-input]');
    var results = $('[data-predictive-results]');
    if (!input || !results) return;
    var t;
    input.addEventListener('input', function () {
      clearTimeout(t);
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      t = setTimeout(function () {
        var url = routes.predictive_search_url +
          '?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection,page&resources[limit]=6' +
          '&section_id=predictive-search';
        fetch(url)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.querySelector('[data-predictive-inner]');
            results.innerHTML = fresh ? fresh.innerHTML : '';
          })
          .catch(function () { results.innerHTML = ''; });
      }, 220);
    });
  }

  /* ----------------------------------------------------------- wishlist */
  var WISH_KEY = 'eman:wishlist';
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISH_KEY)) || []; } catch (e) { return []; }
  }
  function setWishlist(list) {
    localStorage.setItem(WISH_KEY, JSON.stringify(list));
    $$('[data-wishlist-count]').forEach(function (el) { el.textContent = list.length; el.hidden = !list.length; });
  }
  function syncWishButtons() {
    var list = getWishlist();
    $$('[data-wishlist-toggle]').forEach(function (btn) {
      var on = list.indexOf(btn.getAttribute('data-handle')) !== -1;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', String(on));
    });
    setWishlist(list);
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    var handle = btn.getAttribute('data-handle');
    var list = getWishlist();
    var i = list.indexOf(handle);
    if (i === -1) { list.push(handle); toast(btn.getAttribute('data-added-text') || ''); }
    else { list.splice(i, 1); toast(btn.getAttribute('data-removed-text') || ''); }
    setWishlist(list);
    syncWishButtons();
    if (document.body.classList.contains('template-page-wishlist')) renderWishlistPage();
  });

  function renderList(container, handles, emptyEl) {
    if (!container) return;
    if (!handles.length) {
      container.innerHTML = '';
      if (emptyEl) emptyEl.hidden = false;
      return;
    }
    if (emptyEl) emptyEl.hidden = true;
    container.innerHTML = '';
    handles.forEach(function (handle) {
      fetch(routes.root_url.replace(/\/$/, '') + '/products/' + handle + '?section_id=product-card-ajax')
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var card = doc.querySelector('[data-ajax-card]');
          if (card) { container.appendChild(card); syncWishButtons(); }
        })
        .catch(function () {});
    });
  }

  function renderWishlistPage() {
    renderList($('[data-wishlist-grid]'), getWishlist(), $('[data-wishlist-empty]'));
  }

  /* ------------------------------------------------------ recently viewed */
  var RV_KEY = 'eman:recent';
  function trackRecent() {
    var el = $('[data-recent-track]');
    if (!el) return;
    var handle = el.getAttribute('data-recent-track');
    var list;
    try { list = JSON.parse(localStorage.getItem(RV_KEY)) || []; } catch (e) { list = []; }
    list = list.filter(function (h) { return h !== handle; });
    list.unshift(handle);
    localStorage.setItem(RV_KEY, JSON.stringify(list.slice(0, 12)));
  }
  function renderRecent() {
    var wrap = $('[data-recent-grid]');
    if (!wrap) return;
    var current = wrap.getAttribute('data-current-handle');
    var list;
    try { list = JSON.parse(localStorage.getItem(RV_KEY)) || []; } catch (e) { list = []; }
    list = list.filter(function (h) { return h !== current; }).slice(0, 5);
    var section = wrap.closest('[data-recent-section]');
    if (!list.length) { if (section) section.hidden = true; return; }
    if (section) section.hidden = false;
    renderList(wrap, list, null);
  }

  /* --------------------------------------------------------- sticky header */
  function initStickyHeader() {
    var header = $('[data-header]');
    if (!header) return;
    var onScroll = function () { header.classList.toggle('is-stuck', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ------------------------------------------------------- sticky add cart */
  function initStickyAtc() {
    var bar = $('[data-sticky-atc]');
    var anchor = $('[data-atc-anchor]');
    if (!bar || !anchor) return;
    document.body.classList.add('has-sticky-atc');
    var io = new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { rootMargin: '0px 0px -60px 0px' });
    io.observe(anchor);
    bar.querySelector('[data-sticky-add]').addEventListener('click', function () {
      var form = $('form[data-product-form]');
      if (form) form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    });
  }

  /* ---------------------------------------------------------- mobile menu */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('.mobile-nav__toggle');
    if (!toggle) return;
    var expanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!expanded));
    var sub = toggle.nextElementSibling;
    if (sub) sub.classList.toggle('is-open', !expanded);
  });

  /* -------------------------------------------------------------- reveal */
  function initReveal() {
    var els = $$('.reveal');
    if (!els.length || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ------------------------------------------------- whatsapp product link */
  function initWhatsappProduct() {
    var btn = $('[data-wa-product]');
    if (!btn) return;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var root = $('[data-product-root]');
      var lines = [btn.getAttribute('data-intro'), btn.getAttribute('data-product-title')];
      $$('[data-option-index]').forEach(function (group) {
        var sel = group.querySelector('.is-selected');
        if (sel) lines.push(group.getAttribute('data-option-name') + ': ' + sel.getAttribute('data-value'));
      });
      var qty = $('[data-product-qty]');
      if (qty && parseInt(qty.value, 10) > 1) lines.push(btn.getAttribute('data-qty-label') + ': ' + qty.value);
      lines.push(window.location.origin + window.location.pathname);
      var url = 'https://wa.me/' + btn.getAttribute('data-number') + '?text=' + encodeURIComponent(lines.filter(Boolean).join('\n'));
      window.open(url, '_blank', 'noopener');
      if (root) { /* no-op, keeps lint quiet */ }
    });
  }

  /* ------------------------------------------------------ collection sort */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-sort-by]');
    if (!sel) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sel.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  document.addEventListener('change', function (e) {
    var form = e.target.closest('[data-facet-form]');
    if (!form) return;
    if (form.hasAttribute('data-facet-manual')) return; /* drawer: wait for Apply */
    form.submit();
  });

  /* ------------------------------------------------------------------ init */
  function init() {
    initStickyHeader();
    initCarousels();
    initGallery();
    initSearch();
    initReveal();
    initWhatsappProduct();
    initStickyAtc();
    $$('[data-slideshow]').forEach(initSlideshow);
    $$('[data-product-root]').forEach(initProductForm);
    syncWishButtons();
    trackRecent();
    renderRecent();
    if (document.body.classList.contains('template-page-wishlist')) renderWishlistPage();
    fetch(routes.cart_url + '.js').then(function (r) { return r.json(); }).then(function (cart) {
      updateCartCount(cart.item_count);
      renderFreeShipping(cart.total_price);
    }).catch(function () {});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function () { init(); });
})();
